import React from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, InputField, TextareaField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";

function Form({ data, mode, ...rest }) {
    const validationSchema = Yup.object({
        id: Yup.string().required("Required field").max(20),
        name: Yup.string().required("Required field").max(100),
        unitPrice: Yup.number().notRequired().nullable(),
        description: Yup.string().notRequired().nullable().max(500),
    });

    return (
        <FormikForm initialValues={data} validationSchema={validationSchema} {...rest}>
            <div className="layout">
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <FormControl component="fieldset">
                            <FormGroup row>
                                <InputField disabled={mode === "update"} fieldName="id" label="Identifier *" uppercase fullWidth={false} />
                                <InputField fieldName="name" label="Name *" />
                                <InputField fieldName="unitPrice" label="Unit Price" currency placeholder="0" />
                                <TextareaField fieldName="description" label="Description" fullWidth maxLength={500} />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        unitPrice: PropTypes.number,
        description: PropTypes.string,
    }),
};

Form.defaultProps = {
    data: { id: "", name: "", unitPrice: 0, description: "" },
};

export default Form;
